import { Component, OnInit, Input, SimpleChanges, ElementRef, Optional } from '@angular/core';
import { AddEmployeeComponent } from './../../../shared/employee/add-employee/add-employee.component';
import { DialogConfig, DialogRef, DialogService } from 'app/shared/dialog';
import { CreateGroupComponent } from './../../../shared/employee/create-group/create-group.component';
import { AccountMembership, APIService, UpdateAccountMemberActivityInput, UpdateAccountMembershipAction, UpdateAccountMembershipInput, UpdateUserInput, UserStatus } from './../../../../app/API.service.custom'
import { ToastrService } from 'ngx-toastr';
import { DeleteMigrateMemberComponent } from '../../../shared/employee/delete-migrate-member/delete-migrate-member.component';
import {find as _find} from 'lodash-es'
import { DataShareService } from '../../../../services/data-share.service';
import { AuthorizationLevel } from 'app/API.service.custom';
import { TeamInboxComponent } from 'app/shared/conversation/team-inbox/team-inbox.component';
import { Router } from '@angular/router';
import { v4 as uuidv4 } from 'uuid';
import { UploadDoneService } from 'app/shared/upload/upload-done-service';
import { SmxRosterEditorComponent } from 'app/shared/roster/smx-roster-editor/smx-roster-editor.component';
import { NgClass } from '@angular/common';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { FormsModule } from '@angular/forms';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ProfileImageComponent } from '../../profile-image/profile-image.component';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatDivider } from '@angular/material/divider';
import { MatButton } from '@angular/material/button';
import { RenderCustomContactPropertiesComponent } from '../../render-custom-contact-properties/render-custom-contact-properties.component';
import { SwalDirective } from '@sweetalert2/ngx-sweetalert2';
import { FormatDateTimePipe } from '../../../../services/format-date-time.pipe';
import { FormatEnumPipe } from '../../../../services/format-enum.pipe';
import { MembershipfilterPipe } from '../../../../services/membership-filter.pipe';
import { take } from 'rxjs/operators';
import { AppHealthDiagnosticService, HealthIssue, UserHealthReport } from '../app-install-status/app-health-diagnostic.service';
import Swal from 'sweetalert2';
import { MatTooltip } from '@angular/material/tooltip';
import { canAdministerGeofences as canAdministerGeofencesForAccount } from 'app/core/access/route-access-policy';
import { GeofenceAdminService } from 'app/shared/geofence/geofence-admin.service';
import { Geofence, GeofenceMember, enforcedActionLabel } from 'app/shared/geofence/geofence.model';
import {
  GeofenceAssignmentPanelComponent,
  GeofenceAssignmentPanelData,
} from 'app/shared/geofence/geofence-assignment-panel/geofence-assignment-panel.component';


export class UserTableData {
  membershipId: string;
  name: string;
  profilePicture?: string | null;
  userID: string;
  userAccountStatus: string;
  addedDate?: string;
  addedBy?: string;
  addedByProfilePicture?: string | null;
  mobile: string;
  email?: string;
  designation?: string;
  authorization: string;
  prefScreenPop?: Boolean;
  prefSaveBusinessCall?: Boolean;
  prefPostCallDisposition?: Boolean;
  prefTrackAllCalls?: Boolean;
  prefTrackAllCallsSpecificSim?: Number;
  prefDefaultSimToCall?: Number;
  prefTrackLocationOnActivity?: Boolean;
  prefUseBusinessWhatsapp?: Boolean;
}

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    imports: [NgClass, ExtendedModule, FormsModule, NgxIntlTelInputModule, ProfileImageComponent, MatMenuTrigger, MatMenu, MatMenuItem, MatDivider, MatTooltip, RenderCustomContactPropertiesComponent, SwalDirective, FormatDateTimePipe, FormatEnumPipe, MembershipfilterPipe]
})
export class UserComponent implements OnInit {
  @Input() fetchedUserMemberships: AccountMembership[] = [];

  searchValue;
  activAccountSubscription
  activeAccount : AccountMembership = null;
  accountMembershipUpdateInitiated : Boolean = false
  readOnlyUpdatesPending = new Set<string>();

  userTypes = [
    {value : 'invited', viewValue : 'Not Yet Joined'},
  ]

  totalUsers: number = 0;
  totalActiveUsers: number = 0;
  totalInactiveUsers: number = 0;
  totalSeats : number = 0;
  callBeingPlaced = false;
  userHealthMap = new Map<string, UserHealthReport>();
  appIssueUserCount = 0;

  /** ACTIVE geofences on the account, for the assignment panel's picker. */
  geofences: Geofence[] = [];
  /** membershipId -> that member's geofence assignment. */
  geofenceByMembership = new Map<string, GeofenceMember>();

  constructor(
    private sidebarService: DialogService,
    private dataService : DataShareService,
    private api: APIService,
    private toastr: ToastrService,
    private elementRef: ElementRef,
    private data: UploadDoneService,
    private diagnosticService: AppHealthDiagnosticService,
    private geofenceAdmin: GeofenceAdminService,
    private router: Router,
    @Optional() private config: DialogConfig,
    @Optional() public dialog: DialogRef
  ) {
  }



  ngOnInit() {
    console.log("oninit : user memberships are :", this.fetchedUserMemberships);
    this.checkForInviteStatus();
    this.fetchedUserMemberships.sort((a, b) => {
      if (a.userAccountStatus === b.userAccountStatus && a.user && a.user.name && b.user && b.user.name) {
        // If the category is the same, compare by name
        return a.user.name.localeCompare(b.user.name);
      } else {
        // Otherwise, compare by category
        return a.userAccountStatus.localeCompare(b.userAccountStatus);
      }
    });
    this.activAccountSubscription = this.dataService.getActiveAccount().subscribe((param: any) => {
      if (param) {
          this.activeAccount = param;
          this.totalSeats = (this.activeAccount?.account?.seats || 0) + (this.activeAccount?.account?.freeSeats || 0) 
          void this.loadGeofenceAssignments();
      }
    })
    let configData = null;
    if (this.config && this.config.data) {
      configData = this.config.data;
      this.fetchedUserMemberships = configData.fetchedUserMemberships;
      this.checkForInviteStatus();
    }
    this.calculateUserCounts();
  }

  validateInput(value: any): string | undefined {
    return !value ? 'Input is required!' : undefined;
  }

  canManageReadOnlyAccess(member: AccountMembership): boolean {
    return this.activeAccount?.authorizationLevel === AuthorizationLevel.SUPERADMIN &&
      !this.activeAccount.isReadOnlyAccess && member?.accountId === this.activeAccount.accountId;
  }

  async toggleReadOnlyAccess(member: AccountMembership): Promise<void> {
    if (!this.canManageReadOnlyAccess(member) || this.readOnlyUpdatesPending.has(member.id)) return;
    const enabled = member.isReadOnlyAccess !== true;
    // Keep at least one active superadmin able to restore access.
    if (enabled && member.authorizationLevel === AuthorizationLevel.SUPERADMIN &&
        member.userAccountStatus === UserStatus.ACTIVE &&
        !this.fetchedUserMemberships.some(other => other.id !== member.id &&
          other.accountId === member.accountId &&
          other.authorizationLevel === AuthorizationLevel.SUPERADMIN &&
          other.userAccountStatus === UserStatus.ACTIVE && !other.isReadOnlyAccess)) {
      this.toastr.error('Keep at least one active superadmin with write access.');
      return;
    }
    this.readOnlyUpdatesPending.add(member.id);
    try {
      await this.api.UpdateAccountMembershipData({ id: member.id, isReadOnlyAccess: enabled });
      member.isReadOnlyAccess = enabled;
      if (this.activeAccount?.id === member.id) {
        this.dataService.setActiveAccount({ ...this.activeAccount, isReadOnlyAccess: enabled });
      }
      this.dataService.triggerUsersRefresh();
      this.toastr.success(enabled ? 'Read-only access enabled. The user must refresh their session to apply it.' :
        'Write access restored. The user must refresh their session to apply it.');
    } catch (error) {
      if (error?.errors?.length) {
        this.showErrorInToastr(error, 'Error updating read-only access');
      } else {
        this.toastr.error('Could not update read-only access. Please try again.');
      }
    } finally {
      this.readOnlyUpdatesPending.delete(member.id);
    }
  }

  checkForInviteStatus(){
    const pattern = /^[0-9+]+$/;
      for(let _i = 0; _i < this.fetchedUserMemberships.length; _i++){
          let member = this.fetchedUserMemberships[_i]
          if(member.userAccountStatus != 'ACTIVE' || member?.user.name == '' || member?.user.name == null)
            member["notYetJoined"] = true
          else if(pattern.test(member?.user.name)){
            member["notYetJoined"] = false
          }
          else{
            member["notYetJoined"] = false
          }
      }
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("on change : user memberships are :", this.fetchedUserMemberships)
    if (this.fetchedUserMemberships) {
      this.fetchedUserMemberships.sort((a, b) => {
        if (a.userAccountStatus === b.userAccountStatus && a.user && a.user.name && b.user && b.user.name) {
          // If the category is the same, compare by name
          return a.user.name.localeCompare(b.user.name);
        } else {
          // Otherwise, compare by category
          return a.userAccountStatus.localeCompare(b.userAccountStatus);
        }
      });
    }
    this.checkForInviteStatus();
    this.calculateUserCounts();
  }

  calculateUserCounts() {
    this.totalUsers = this.fetchedUserMemberships.length;
    this.totalActiveUsers = this.fetchedUserMemberships.filter(member => member.userAccountStatus === 'ACTIVE').length;
    this.totalInactiveUsers = this.fetchedUserMemberships.filter(member => member.userAccountStatus === 'INACTIVE').length;
    this.runAppDiagnostics();
  }

  getUserHealth(member: AccountMembership): UserHealthReport | null {
    return this.userHealthMap.get(member.userId) || null;
  }

  getActionableCount(health: UserHealthReport | null): number {
    if (!health) return 0;
    return this.getPotentialActionableIssues(health).length;
  }

  getActionableTitle(health: UserHealthReport): string {
    const actionable = this.getPotentialActionableIssues(health)[0];
    return actionable?.title || '';
  }

  hasCriticalIssue(health: UserHealthReport): boolean {
    return this.getPotentialActionableIssues(health).some(i => i.severity === 'critical');
  }

  getPotentialActionableIssues(health: UserHealthReport | null): HealthIssue[] {
    if (!health) return [];
    return health.issues.filter(i =>
      i.category === 'potential' &&
      !i.policyExpected &&
      (i.severity === 'critical' || i.severity === 'warning')
    );
  }

  // --------------------------------------------------------------- geofence

  /** Geofence administration is SUPERADMIN-only, matching the settings route. */
  canAdministerGeofences(): boolean {
    return canAdministerGeofencesForAccount(this.activeAccount);
  }

  /**
   * Loads geofences and every member's assignment.
   *
   * Assignment is NOT on `fetchedUserMemberships` — the parent's `UsersByAccount`
   * projection deliberately does not select the geofence fields, because that
   * query also runs on the bootstrap path. This reads them from the geofence
   * service's own projection instead.
   */
  private async loadGeofenceAssignments(): Promise<void> {
    const accountId = this.activeAccount?.accountId;
    if (!accountId || !this.canAdministerGeofences()) return;

    try {
      const [geofences, members] = await Promise.all([
        this.geofenceAdmin.listGeofences(accountId),
        this.geofenceAdmin.listMembers(accountId),
      ]);
      this.geofences = geofences;
      this.geofenceByMembership = new Map(members.map(m => [m.membershipId, m]));
    } catch (e) {
      // Non-fatal: the rest of the user list must still work, so this stays a
      // console note rather than a toast about something the admin did not do.
      console.log('Could not load geofence assignments', e);
    }
  }

  geofenceNameFor(member: AccountMembership): string | null {
    const assignment = this.geofenceByMembership.get(member.id);
    if (!assignment?.operatingGeofenceId) return null;
    const match = this.geofences.find(g => this.geofenceAdmin.matchesMember(g, assignment));
    return match?.name || 'Unknown geofence';
  }

  /** Enforced actions with no geofence to check against: every one is denied. */
  isGeofenceFailClosed(member: AccountMembership): boolean {
    const assignment = this.geofenceByMembership.get(member.id);
    return !!assignment && !assignment.operatingGeofenceId && assignment.geofenceEnforcedActions.length > 0;
  }

  geofenceTooltip(member: AccountMembership): string {
    const assignment = this.geofenceByMembership.get(member.id);
    if (!assignment?.geofenceEnforcedActions?.length) {
      return 'Assigned, but no action is restricted to this area yet.';
    }
    return 'Restricted: ' + assignment.geofenceEnforcedActions.map(a => enforcedActionLabel(a)).join(', ');
  }

  openGeofencePanel(member: AccountMembership): void {
    const accountId = this.activeAccount?.accountId;
    if (!accountId) return;

    const assignment: GeofenceMember = this.geofenceByMembership.get(member.id) || {
      membershipId: member.id,
      userId: member.userId,
      name: member.user?.name || member.designation || 'Unnamed member',
      designation: member.designation,
      authorizationLevel: member.authorizationLevel,
      userAccountStatus: member.userAccountStatus,
      operatingGeofenceId: null,
      geofenceEnforcedActions: [],
    };

    const data: GeofenceAssignmentPanelData = { member: assignment, geofences: this.geofences, accountId };
    const ref = this.sidebarService.open(GeofenceAssignmentPanelComponent, {
      data,
      ariaLabel: `Geofence settings for ${assignment.name}`,
    });

    ref.afterClosed.pipe(take(1)).subscribe((result: any) => {
      if (!result?.membershipId) return;
      // Patch in place — the write already succeeded, and refetching would flicker
      // the whole user list for information we already have.
      this.geofenceByMembership.set(result.membershipId, {
        ...assignment,
        operatingGeofenceId: result.operatingGeofenceId,
        geofenceEnforcedActions: result.geofenceEnforcedActions,
      });
    });
  }

  goToAppStatus(): void {
    if (this.dialog) { this.dialog.close(); }
    this.router.navigate(['/admin/users'], { queryParams: { tab: 'app' } });
  }

  private runAppDiagnostics(): void {
    if (!this.fetchedUserMemberships?.length || !this.activeAccount) return;
    const permissionsMap = this.diagnosticService.parseAccountPermissions(this.activeAccount?.account?.permissions);
    const report = this.diagnosticService.diagnoseAll(this.fetchedUserMemberships, permissionsMap);
    this.userHealthMap = new Map(report.userReports.map(r => [r.member.userId, r]));
    this.appIssueUserCount = report.counts.needsAction + report.counts.notInstalled;
  }

  modifyName(ev : any, member : AccountMembership){
    console.log("Event received ", ev);
    if(!ev || ev == '' || ev.length < 3){
      this.toastr.error("Please enter at least 3 characters for name");
      return;
    }
    let i = <UpdateUserInput>{};
    i.name = ev;
    i.id = member.userId;
    this.api.UpdateUser(i).then(event => {
      this.toastr.success('Name Updated');
      member.user.name = ev;
      if (this.activeAccount?.userId === member.userId && this.activeAccount.user) {
        this.activeAccount.user.name = ev;
      }
      this.dataService.triggerUsersRefresh();
    })
      .catch(e => {
        this.showErrorInToastr(e, 'Error in Updating Name');
      });
  }
  
  closeDialog(){
    if(this.dialog)
      this.dialog.close();
  }

  addEmployeeButtonClicked(): void {
    this.closeDialog();
    this.sidebarService.open(AddEmployeeComponent, {});
  }

  ngOnDestroy(): void {
    if (this.activAccountSubscription && !this.activAccountSubscription.closed)
      this.activAccountSubscription.unsubscribe();
  }

  modifyEmployeeButtonClicked(member : AccountMembership): void {
    let ref = null;
    this.closeDialog();
    ref = this.sidebarService.open(AddEmployeeComponent, {
      data: {mode : 'edit', memberToEdit : member}
    });

    ref.afterClosed.pipe(take(1)).subscribe(result => {
      console.log('Dialog closed', result);
      if(result != null){
        let modifiedMembership = result as AccountMembership;
        member = modifiedMembership;
        this.fetchedUserMemberships = [...this.fetchedUserMemberships];
        this.data.refreshParentData();
      }
    });
  }

  addToGroup(): void {
    this.closeDialog();
    let ref = this.sidebarService.open(CreateGroupComponent, {
      data: {}
    });
    
  }

  removeUser(member : AccountMembership) {
    if(member.authorizationLevel == AuthorizationLevel.SUPERADMIN){
      //Check if there is any other Superadmin in account
      let superadmins =  this.fetchedUserMemberships.filter(obj => obj.authorizationLevel == AuthorizationLevel.SUPERADMIN);
      if(superadmins && superadmins.length == 1){
        this.toastr.error("You are the only superadmin in the account. Each account must have one superadmin, so you can't delete this user.")
      }else if(superadmins && superadmins.length > 1){
        this.closeDialog();
        this.sidebarService.open(DeleteMigrateMemberComponent, {
          data: { action: 'remove', memberToRemove : member, allMembers : this.fetchedUserMemberships }
        });
      }
    }else{
      this.closeDialog();
      this.sidebarService.open(DeleteMigrateMemberComponent, {
        data: { action: 'remove', memberToRemove : member, allMembers : this.fetchedUserMemberships }
      });
    }
  }

  migrateUser(member : AccountMembership) {
    this.closeDialog();
    this.sidebarService.open(DeleteMigrateMemberComponent, {
      data: { action: 'migrate', memberToRemove : member }
    }); 
  }

  async reIncludeInSupport(member: AccountMembership) {
    if (!member?.id || !member?.excludedFromSalesmaxSupport) return;
    const displayName = member?.user?.name || 'this user';
    const confirm = await Swal.fire({
      title: `Re-include ${displayName} in support chat?`,
      html: `<b>${displayName}</b> will be re-added to the SalesMax support channel for this account.`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Re-include',
    });
    if (!confirm.isConfirmed) return;
    const input = <UpdateAccountMembershipInput>{};
    input.id = member.id;
    input.excludedFromSalesmaxSupport = false;
    try {
      await this.api.UpdateAccountMembershipData(input);
      member.excludedFromSalesmaxSupport = false;
      this.dataService.triggerUsersRefresh();
      this.toastr.success('User will be added to support chat in next sync within 24 hours');
    } catch (e) {
      console.log('Error re-including user in support', e);
      this.showErrorInToastr(e, 'Error re-including user in support');
    }
  }

  approveUser(member : AccountMembership) {
    if(!this.accountMembershipUpdateInitiated){
      this.accountMembershipUpdateInitiated = true;
      let input = <UpdateAccountMembershipInput>{};
      input.id = member.id;
      input.updateAction = UpdateAccountMembershipAction.APPROVE_MEMBERSHIP;
      this.api.UpdateAccountMembership(input).then(event => {
        this.accountMembershipUpdateInitiated = false;
        console.log('Membership Approved : ', event);
        this.toastr.success('User Approved in Team Plan');
        member.userAccountStatus = UserStatus.APPROVED;
      })
        .catch(e => {
          this.accountMembershipUpdateInitiated = false;
          console.log('Error in Membership Approval', e);
          this.showErrorInToastr(e, 'Error in Membership Approval');
        });
      }
  }

  disapproveUser(member : AccountMembership) {
    if(!this.accountMembershipUpdateInitiated){
      this.accountMembershipUpdateInitiated = true;
      let input = <UpdateAccountMembershipInput>{};
      input.id = member.id;
      input.updateAction = UpdateAccountMembershipAction.DISAPPROVE_MEMBERSHIP;
      this.api.UpdateAccountMembership(input).then(event => {
        this.accountMembershipUpdateInitiated = false;
        console.log('Membership Disapproved : ', event);
        this.toastr.success('User Denied Approval in Team Plan');
      })
        .catch(e => {
          this.accountMembershipUpdateInitiated = false;
          console.log('Error in Membership dispproval', e);
          this.showErrorInToastr(e, 'Error in Membership dispproval')
        });
    }
  }

  changeActiveStatus(member : AccountMembership, status : string){
    if(this.activeAccount.authorizationLevel == 'SUPERADMIN'){
    if(!this.accountMembershipUpdateInitiated){
      this.accountMembershipUpdateInitiated = true;
      let input = <UpdateAccountMembershipInput>{};
      input.id = member.id;
      if(status == "INACTIVE")
        input.updateAction = UpdateAccountMembershipAction.MAKE_INACTIVE;
      else if(status == "ACTIVE")
        input.updateAction = UpdateAccountMembershipAction.MAKE_ACTIVE;
      return this.api.UpdateAccountMembership(input).then(event => {
        this.accountMembershipUpdateInitiated = false;
        console.log('Membership status changed : ', event);
        // Apply the successful write immediately; a page reload can reuse stale users.
        member.userAccountStatus = status as UserStatus;
        this.checkForInviteStatus();
        this.calculateUserCounts();
        this.dataService.triggerUsersRefresh();
        if (status == "ACTIVE") {
          // Reactivating an already-signed-in user: their existing token does not
          // carry this accountId, so a fresh sign-in is required for access to take effect.
          Swal.fire({
            title: 'User activated successfully',
            html: 'They may need to sign out and sign in again on all devices (mobile and web) before they can access this workspace.',
            icon: 'success',
            confirmButtonText: 'Got it',
            allowOutsideClick: false,
          });
        } else {
          this.toastr.success(`Membership status changed to ${status}`);
        }
      })
        .catch(e => {
          this.accountMembershipUpdateInitiated = false;
          console.log('Error in changing membership status', e);
          this.showErrorInToastr(e, 'Error in changing membership status')
        });
    }
  }
  else{
    this.toastr.error("Only Superadmin can take this action");
  }
  }

  startChatWithUser(member : AccountMembership){
    let ref = this.sidebarService.open(TeamInboxComponent, {
      data: { selectedChatUserId: member.userId, viewMode: 'dialog-mode' }
    }, 1);
  }

  setRoster(member : AccountMembership){
    let ref = this.sidebarService.open(SmxRosterEditorComponent, {
      data: { member: member }
    }, 1);

    ref.afterClosed.pipe(take(1)).subscribe(result => {
        if (result) {
          console.log("roaster is ", result);
        }
      })
  }

  goToUserPhoneCallClicked(member : AccountMembership) {
    if (!this.callBeingPlaced) {
      this.callBeingPlaced = true;
      let selectedUserId = member.userId;
      let phoneNumber = member.user?.registeredNumber;
      let dateString = (new Date()).toISOString();
      let i = <UpdateAccountMemberActivityInput>{}
      i.accountId = this.activeAccount.accountId;
      i.userId = this.activeAccount.userId;
      i.inCall = "PLACE_CALL";
      i.inCallWithContactId = null;
      i.inCallWithContactNumber = phoneNumber;
      i.inCallWithContactName = member.user?.name || 'employee';
      i.callPlacementId = uuidv4();
      i.inCallRequestedAt = dateString;
      i.lastInCallUpdatedAt = dateString;
      this.api.UpdateAccountMemberActivity(i).then(event => {
        console.log('Initiated Call : ', event);
        this.toastr.success('Initiated Call');
        this.callBeingPlaced = false;
      })
        .catch(e => {
          this.callBeingPlaced = false;
          console.log('Error Initiating Call', e);
          this.showErrorInToastr(e, 'Error Initiating Call')
        });
    }
  }

  showErrorInToastr(e, title) {
    if (e.errors && e.errors.length > 0) {
      for (let _i = 0; _i < e.errors.length; _i++) {
        this.toastr.error(title, e.errors[_i].message);
        console.log(e.errors[_i].message);
      }
    }
  }

}
